import { alpha, PaletteOptions } from '@mui/material';
import { capitalDesignTokens } from './capital_design_tokens';

const black = capitalDesignTokens.foundations.colors.black;
const white = capitalDesignTokens.foundations.colors.white;
const contrastText = alpha(black, 0.87);

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  divider: alpha(white, 0.12),
  // 4.07:1 on paper (gray1000), 3.94:1 on the default background (black), 3.60:1 on the secondary
  // background (gray900). `divider` is 1.44:1 on paper.
  outline: alpha(white, 0.42),
  text: {
    primary: white,
    secondary: alpha(white, 0.63),
    disabled: alpha(white, 0.46)
  },
  primary: {
    main: capitalDesignTokens.foundations.colors.blurple200,
    dark: capitalDesignTokens.foundations.colors.blurple400,
    light: capitalDesignTokens.foundations.colors.blurple50,
    contrastText
  },
  secondary: {
    main: capitalDesignTokens.foundations.colors.purple200,
    dark: capitalDesignTokens.foundations.colors.purple400,
    light: capitalDesignTokens.foundations.colors.purple50,
    contrastText
  },
  action: {
    active: alpha(white, 0.56),
    hover: alpha(white, 0.08),
    selected: alpha(white, 0.16),
    focus: alpha(white, 0.22),
    disabled: alpha(white, 0.38),
    disabledBackground: alpha(white, 0.12)
  },
  error: {
    main: capitalDesignTokens.foundations.colors.red300,
    dark: capitalDesignTokens.foundations.colors.red700,
    light: capitalDesignTokens.foundations.colors.red50,
    contrastText
  },
  warning: {
    main: capitalDesignTokens.foundations.colors.orange300,
    dark: capitalDesignTokens.foundations.colors.yellow700,
    light: capitalDesignTokens.foundations.colors.yellow50,
    contrastText
  },
  success: {
    main: capitalDesignTokens.foundations.colors.green300,
    dark: capitalDesignTokens.foundations.colors.green700,
    light: capitalDesignTokens.foundations.colors.green50,
    contrastText
  },
  info: {
    main: capitalDesignTokens.foundations.colors.cerulean300,
    dark: capitalDesignTokens.foundations.colors.cerulean700,
    light: capitalDesignTokens.foundations.colors.cerulean50,
    contrastText
  },
  common: {
    black,
    white
  },
  background: {
    default: black,
    paper: capitalDesignTokens.foundations.colors.gray1000,
    secondary: capitalDesignTokens.foundations.colors.gray900
  },
  blue: {
    main: capitalDesignTokens.foundations.colors.blue300,
    dark: capitalDesignTokens.foundations.colors.blue700,
    light: capitalDesignTokens.foundations.colors.blue50,
    contrastText
  },
  orange: {
    main: capitalDesignTokens.foundations.colors.orange300,
    dark: capitalDesignTokens.foundations.colors.orange700,
    light: capitalDesignTokens.foundations.colors.orange50,
    contrastText
  },
  inProgress: {
    main: capitalDesignTokens.foundations.colors.purple300,
    dark: capitalDesignTokens.foundations.colors.purple700,
    light: capitalDesignTokens.foundations.colors.purple50,
    contrastText
  },
  cerulean: {
    main: capitalDesignTokens.foundations.colors.cerulean300,
    dark: capitalDesignTokens.foundations.colors.cerulean700,
    light: capitalDesignTokens.foundations.colors.cerulean50,
    contrastText
  },
  // Shadowed palette entries mirror the dark-mode main for each color.
  // Used by loading indicators and progress track overlays.
  primaryShadowed: {
    main: capitalDesignTokens.foundations.colors.blurple200
  },
  secondaryShadowed: {
    main: capitalDesignTokens.foundations.colors.gray200
  },
  errorShadowed: {
    main: capitalDesignTokens.foundations.colors.red300
  },
  warningShadowed: {
    main: capitalDesignTokens.foundations.colors.orange300
  },
  successShadowed: {
    main: capitalDesignTokens.foundations.colors.green300
  },
  infoShadowed: {
    main: capitalDesignTokens.foundations.colors.cerulean300
  }
};
